module.exports = __webpack_public_path__ + "img/service_jinrong.470c7326.jpg";